const VimeoPlayer = require('@vimeo/player');
const YouTubePlayer = require('youtube-player');
const _ = require('lodash');

// https://github.com/vimeo/player.js/
class Vimeo {
  playVideo() {
    this.player.play().then(() => {}).catch(function(error) {
      //console.error('play video', error);
    });
  }

  resizeHelper() {
    const self = this;
    this.player.ready().then(function(){
      Promise.all([self.player.getVideoWidth(), self.player.getVideoHeight()]).then(function(dimensions) {
        var width = dimensions[0];
        var height = dimensions[1];
        var ratio = height / width;

        const calc = function() {
          if (self.ratio > ratio) {
            let unit = Math.ceil(self.height);
            // bind height
            self.el.css({
              'width': unit / ratio,
              'height': unit
            });
          } else {
            // bind width
            let unit = Math.ceil(self.width);
            self.el.css({
              'width': unit,
              'height': unit * ratio
            });
          }
        };
        calc();
        $(window).resize(_.debounce(() => {
          calc();
        }));
      });
    })

  }

  resetVideo() {
    // reset the time back to the start
    this.player.setCurrentTime(0).then((seconds) => {
      //console.log('set time to zero success', seconds);
    }).catch(function(error) {
      //console.error('set time to zero error', error);
    });
  }

  constructor(el) {
    this.el = $(el);
    this.parent = this.el.parent();
    this.id = this.el.data('id');
    this.background = this.el.hasClass('background');
    this.inGallery = this.el.hasClass('is-in-gallery');
    // this.width = this.el.innerWidth();
    this.width = this.parent.innerWidth();
    // this.height = this.el.innerHeight();
    this.height = this.parent.innerHeight();
    this.ratio = this.height / this.width;


    $(window).resize(_.debounce(() => {
      this.width = this.parent.innerWidth();
      this.height = this.parent.innerHeight();
      this.ratio = this.height / this.width;
    }, 100));

    let options = {
      id: this.id,
      width: this.el.innerWidth(),
      loop: true,
      responsive: false,
      quality: '1080p',
      autopause: true,
      background: true // Added this line to hide the Vimeo placeholder image
    };

    if (this.background) {
      options = Object.assign(options, {
        muted: true,
        controls: false
      });
    }

    this.player = new VimeoPlayer(el, options);

    // Play the video only after user interaction
    $(window).on('click', () => {
      this.player.play().catch(function(error) {
        console.error('Failed to play video:', error);
      });
    });

    window.videos.push({
      id: this.id,
      video: this
    });
  }
}


// https://github.com/gajus/youtube-player
class Youtube {
  constructor(el) {
    let $this = $(el);
    let ratio = 0.5625; // 16:9
    this.background = $this.hasClass('background');

    this.player = YouTubePlayer(el, {
      width: $this.innerWidth(),
      height: $this.innerWidth() * ratio,
      videoId: $this.data('id'),
      autoplay: this.background ? 1 : 0,
      controls: this.background ? 0 : 1,
    });

    this.player.on('ready', (event) => {
      let $player = $(event.target.getIframe());
      let calc = () => {

        event.target.setSize($player.innerWidth(), $player.innerWidth() * ratio);
      };
      $(window).resize(_.debounce(() => {
        calc();
      }, 100));
      calc();
    });

    window.videos.push(this);
  }
}

module.exports = {
  Vimeo,
  Youtube
};